module.exports = __webpack_public_path__ + "img/rw.664b001e.png";